/* eslint-disable @typescript-eslint/no-explicit-any */
"use client";

import {
  Carousel,
  CarouselContent,
  CarouselDots,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/components/ui/carousel";
import TestimonialCard from "../testimonial";
import Autoplay from "embla-carousel-autoplay";
import { RecommendUsSkeleton } from "./components/loader";
import { cn } from "@/lib/utils";

const RecommendUs = ({
  data: feedbacks,
  isLoading,
  className,
}: {
  data: any;
  isLoading: boolean;
  className?: string;
}) => {
  if (isLoading) return <RecommendUsSkeleton />;
  if (feedbacks?.length === 0) return null;
  return (
    <section
      id="reviews"
      className={cn("z-30 bg-slate-50 py-12 lg:py-32", className)}
    >
      <div className="container flex flex-col justify-center gap-y-8 lg:gap-y-24">
        <h3 className="text-primary text-center text-3xl font-semibold lg:text-7xl">
          Our user{" "}
          <span className="font-vollkorn pr-4 font-normal italic">
            Love To Recommend
          </span>
          Us
        </h3>
        <Carousel
          plugins={[
            Autoplay({
              delay: 5000,
              stopOnInteraction: false,
              stopOnMouseEnter: true,
            }),
          ]}
        >
          <CarouselContent>
            {feedbacks?.map((feedback: any, index: number) => (
              <CarouselItem key={index}>
                <TestimonialCard data={feedback} />
              </CarouselItem>
            ))}
          </CarouselContent>
          <CarouselDots />
          <CarouselPrevious />
          <CarouselNext />
        </Carousel>
      </div>
    </section>
  );
};

export default RecommendUs;
